import React from 'react';
import { FileText } from 'lucide-react';
import { PdfDocumentViewer } from '../../../../../components/PdfDocumentViewer';
import {
  isImageUrl,
  isOmdPdfDocument,
  type OmdDocument,
} from '../../../utils/omdProductView';

type OmdDocumentPreviewProps = {
  doc: OmdDocument;
  /** Card thumbnail: never iframe the file (that would trigger downloads). */
  compact?: boolean;
  className?: string;
};

export function OmdDocumentPreview({ doc, compact, className }: OmdDocumentPreviewProps) {
  const [thumbnailFailed, setThumbnailFailed] = React.useState(false);
  const url = doc.url ?? '';
  const thumbnail = doc.urlThumbnail?.trim();

  if (thumbnail && !thumbnailFailed) {
    return (
      <img
        src={thumbnail}
        alt=""
        className={className ?? 'w-full h-full object-contain'}
        loading="lazy"
        onError={() => setThumbnailFailed(true)}
      />
    );
  }

  if (url && isImageUrl(url, doc.filename)) {
    return (
      <img
        src={url}
        alt=""
        className={className ?? 'w-full h-full object-contain'}
        loading="lazy"
      />
    );
  }

  // Compact cards must not iframe the file. OMD URLs often have no thumbnail and
  // are served as attachments (or CAD/ZIP behind a datasheet type). Chrome then
  // downloads every document as soon as the Dokumente tab mounts.
  if (compact) {
    return <FileText className="w-10 h-10 text-app-text-subtle" />;
  }

  if (url && isOmdPdfDocument(doc)) {
    return (
      <PdfDocumentViewer
        url={url}
        title={doc.filename || 'PDF'}
        className={className ?? 'h-full w-full bg-app-surface'}
      />
    );
  }

  return <FileText className="w-10 h-10 text-app-text-subtle" />;
}
